import React from 'react';

export default function TestimonialsSectionTestimonials2() {
    return (
        <React.Fragment>
            <>
                <section className="py-36 bg-white overflow-hidden">
  <div className="container px-4 mx-auto">
    <div className="flex justify-center">
      <div className="relative overflow-hidden rounded-3xl">
        <img className="transform hover:scale-105 transition ease-in-out duration-1000" src="flaro-assets/images/testimonials/contact.png" alt />
        <div className="absolute left-0 top-0 px-14 py-11 w-3/4 md:w-1/2 bg-white bg-opacity-30 overflow-y-auto h-full" style={{backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)'}}>
          <svg className="mb-20" width={47} height={36} viewBox="0 0 47 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 36V25.6999C0 22.7377 0.554721 19.6578 1.66416 16.46C2.80722 13.2286 4.35372 10.1823 6.30365 7.32118C8.2872 4.42637 10.5061 1.98598 12.9603 0L21.4324 5.5035C19.4489 8.4993 17.7847 11.6297 16.4399 14.8948C15.1288 18.1262 14.49 21.6943 14.5236 25.5989V36H0ZM25.5676 36V25.6999C25.5676 22.7377 26.1223 19.6578 27.2318 16.46C28.3748 13.2286 29.9213 10.1823 31.8712 7.32118C33.8548 4.42637 36.0737 1.98598 38.5279 0L47 5.5035C45.0165 8.4993 43.3523 11.6297 42.0075 14.8948C40.6964 18.1262 40.0576 21.6943 40.0912 25.5989V36H25.5676Z" fill="#4F46E5" />
          </svg>
          <h3 className="mb-8 text-3xl font-semibold leading-snug">Novovida is a modern, spacious gym in the city center, featuring top-notch equipment, specialized studios, personal trainers, and diverse group classes. Amenities incl</h3>
          <h4 className="mb-1 font-bold">Jenny Wilson</h4>
          <p className="text-gray-600 font-medium">Senior UX Designer</p>
        </div>
      </div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

